import { IAskAiChatMessage, MessageRole, TurnStatus } from '@/creditflowresearch/domain/vo/AskAiChat';
import AssistantMessage from './AssistantMessage';
import UserMessage from './UserMessage';

interface IMessageProps {
  message: IAskAiChatMessage,
  turnStatus?: TurnStatus,
  onRetry: (messageId: string) => void,
  onEdit: (messageId: string) => void,
}

const Message = ({ message, turnStatus, onRetry, onEdit }: IMessageProps) => {
  if (message.role === MessageRole.User) {
    return <UserMessage message={ message } turnStatus={ turnStatus } onRetry={ onRetry } />;
  }

  return <AssistantMessage message={ message } turnStatus={ turnStatus } onRetry={ onRetry } onEdit={ onEdit } />;
};

export default Message;
